import {Injectable, EventEmitter} from '@angular/core';
import IBroadcastMessage from '../interfaces/IBroadcastMessage';

@Injectable()
class Broadcaster extends EventEmitter<IBroadcastMessage> {
    constructor() {
        super();
    }
}

export default Broadcaster;






// WEBPACK FOOTER //
// ./src/app/services/broadcaster.service.ts